import isACookieProduct from '../isACookieProduct';

const useIsCartHasHamper = (cart: any) => {
    let hasHamper = false;
    const hasCartItems =
        cart !== null && cart?.products?.length > 0 ? true : false;
    if (hasCartItems) {
        const productCarts = cart.products;
        for (const cartProductIndex in productCarts) {
            const product = productCarts[cartProductIndex];

            if (!isACookieProduct(product.name)) {
                hasHamper = true;
                break;
            }
        }
    }

    return hasHamper;
};

export default useIsCartHasHamper;
